'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin'],
  isSandbox: global.isSandbox,
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 31
// module chunks = 0